import { Button, Modal, Typography } from "antd";
import TextArea from "antd/es/input/TextArea";
import Title from "antd/es/typography/Title";
import React, { useState } from "react";
import { CommentsAPI } from "../../API/CommentsAPI";
import { COMMENT_INITIAL_OBJECT } from "../../screens/Rankings/RankingsUtils";
const { Text } = Typography;

export const AddComments = ({
  open,
  setOpen,
  selectedID,
  listData,
  setListData,
  messageToast,
  assigneeOptions,
}) => {
  const [inputElements, setInputElements] = useState({
    ...COMMENT_INITIAL_OBJECT,
  });
  const [btnLoading, setBtnLoading] = useState(false);

  function formValidation() {
    const isCommentsValid =
      inputElements.comments && inputElements.comments.trim() !== ""
        ? true
        : false;

    const updatedObj = {
      ...inputElements,
      errorFieds: {
        comments: isCommentsValid ? "" : "Comment is required",
      },
    };

    setInputElements(updatedObj);

    return isCommentsValid;
  }

  async function applyFun() {
    if (formValidation()) {
      setBtnLoading(true);
      const bodyData = {
        flight_model: localStorage.getItem("flight_model"),
        id: selectedID,
        comment: inputElements.comments,
        user: localStorage.getItem("loged-user"),
      };
      await CommentsAPI.addComment(bodyData)
        .then((res) => {
          if (res.data?.status === true) {
            setOpen(false);
            setInputElements({ ...COMMENT_INITIAL_OBJECT });
            let arr = [...listData];
            arr.map((ele) => {
              if (ele.id === selectedID) {
                ele.have_comments = true;
              }
              return ele;
            });
            setListData(arr);
            messageToast("success", res.data?.message);
          } else {
            messageToast("error", res.data?.message);
          }
        })
        .catch((err) => {
          messageToast("error", "Internal Server Error");
        })
        .finally(() => {
          setOpen(false);
          setBtnLoading(false);
        });
    }
  }

  function cancelFun() {
    setInputElements(COMMENT_INITIAL_OBJECT);
    setOpen(false);
  }

  function inputOnChangeFun(value, prop, error) {
    setInputElements((prev) => ({
      ...prev,
      [prop]: value,
      errorFieds: {
        ...prev.errorFieds,
        [prop]: !value ? error : "",
      },
    }));
  }

  return (
    <Modal
      open={open}
      onCancel={() => cancelFun()}
      footer={[
        <Button key="back" type="text" onClick={cancelFun}>
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={applyFun}
          loading={btnLoading}
        >
          Comment
        </Button>,
      ]}
    >
      <div style={{ padding: "10px" }}>
        <div
          style={{ marginBottom: "20px", borderBottom: "solid 1px #80808047" }}
        >
          <Title level={5}>Add Comments</Title>
        </div>

        <div>
          <label>Comment</label>
          <TextArea
            status={!inputElements.errorFieds.comments ? "" : "error"}
            rows={4}
            value={inputElements.comments}
            onChange={(e) => {
              const value = e.target.value.trimStart();
              inputOnChangeFun(value, "comments", "Comment is required");
            }}
          />
          <Text type="danger" italic>
            {inputElements.errorFieds.comments}
          </Text>
        </div>
      </div>
    </Modal>
  );
};
